import { render, staticRenderFns } from "./status-cell.vue?vue&type=template&id=4896d83c&scoped=true&"
import script from "./status-cell.vue?vue&type=script&lang=js&"
export * from "./status-cell.vue?vue&type=script&lang=js&"
import style0 from "./status-cell.vue?vue&type=style&index=0&id=4896d83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896d83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4896d83c')) {
      api.createRecord('4896d83c', component.options)
    } else {
      api.reload('4896d83c', component.options)
    }
    module.hot.accept("./status-cell.vue?vue&type=template&id=4896d83c&scoped=true&", function () {
      api.rerender('4896d83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table/candidates/status-cell.vue"
export default component.exports